import { useMemo } from 'react';

export function useResolvedMonths(options: {
  defaultMonth?: Date;
  endMonth?: Date;
  maxDate?: Date | null;
  minDate?: Date;
  numberOfMonths: number;
  selectedFrom?: Date;
  startMonth?: Date;
}) {
  const {
    defaultMonth,
    endMonth,
    maxDate,
    minDate,
    numberOfMonths,
    selectedFrom,
    startMonth,
  } = options;

  const resolvedStartMonth = useMemo(
    () => startMonth ?? minDate ?? undefined,
    [startMonth, minDate],
  );

  const resolvedEndMonth = useMemo(() => {
    if (endMonth) {
      return endMonth;
    }

    if (maxDate) {
      return maxDate;
    }

    const base = defaultMonth ?? selectedFrom ?? new Date();
    const monthsToAdd = Math.max(0, numberOfMonths - 1);
    const future = new Date(base.getFullYear() + 10, base.getMonth(), 1);
    const extended = new Date(
      future.getFullYear(),
      future.getMonth() + monthsToAdd + 1,
      0,
    );

    return extended;
  }, [defaultMonth, endMonth, maxDate, numberOfMonths, selectedFrom]);

  const resolvedDefaultMonth = useMemo(() => {
    const candidate = defaultMonth ?? selectedFrom ?? new Date();
    return new Date(candidate);
  }, [defaultMonth, selectedFrom]);

  return {
    resolvedDefaultMonth,
    resolvedEndMonth,
    resolvedStartMonth,
  } as const;
}
